import jsonPromoTypes from '../../dictionaries/promoTypes.json'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export const promoTypes = {
    state: {
        promoTypes: [],
        status: 'idle',
        typesBonded: [
            PROMO_TYPES.BONDED,
            PROMO_TYPES.BONDED_PERCENTAGE,
            PROMO_TYPES.BONDED_QUOTA
        ],
        typesMix: [
            PROMO_TYPES.MIX,
            PROMO_TYPES.MIX1
        ],
        typesSet: [
            PROMO_TYPES.BONDED,
            PROMO_TYPES.BONDED_PERCENTAGE,
            PROMO_TYPES.BONDED_QUOTA,
            PROMO_TYPES.MIX,
            PROMO_TYPES.MIX1
        ],
        typesWeight: [
            PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.WEIGHT_REGULAR_PRICE
        ],
        typesPromoEdit: [
            PROMO_TYPES.PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.MIX1,
            PROMO_TYPES.WEIGHT_REGULAR_PRICE,
            PROMO_TYPES.REGULAR_PRICE,
            PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.BONDED,
            PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
        ],
        typesPromoLabel: [
            PROMO_TYPES.PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.REGULAR_PRICE,
            PROMO_TYPES.WEIGHT_REGULAR_PRICE,
            PROMO_TYPES.MIX1,
            PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.PROMO_ITEM_FIXED_PRICE
        ],
        typesMargin: [
            PROMO_TYPES.PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.ADVERTISEMENT,
            PROMO_TYPES.REGULAR_PRICE,
            PROMO_TYPES.WEIGHT_REGULAR_PRICE,
            PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION,
            PROMO_TYPES.BONDED,
            PROMO_TYPES.MIX1
        ],
        typesNoItems: [
            PROMO_TYPES.ADVERTISEMENT
        ],
        typesNoNetReturn: [
            PROMO_TYPES.ADVERTISEMENT
        ],
        enableTypesPromoByLabelFormat: {
            normal: [],
            large: [
                PROMO_TYPES.WEIGHT_REGULAR_PRICE,
                PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION
            ],
            large2: [
                PROMO_TYPES.REGULAR_PRICE,
                PROMO_TYPES.WEIGHT_REGULAR_PRICE
            ]
        }
    },
    mutations: {
        SET_PROMOTYPES(state, payload) {
            state.promoTypes = payload
        },
        SET_PROMOTYPES_STATUS(state, payload) {
            state.status = payload
        }
    },
    actions: {
        promoTypesFetch({ commit, state }) {
            if (state.status === 'idle') {
                commit('SET_PROMOTYPES_STATUS', 'loading')
                this.$api
                    .get('promo_types')
                    .then(({ data, status }) => {
                        if (status !== 200 || !data?.data) {
                            throw new Error(data?.message || 'Failed GET favorites')
                        }

                        commit('SET_PROMOTYPES', data.data || [])
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        commit('SET_PROMOTYPES_STATUS', 'idle')
                    })
            }
        }
    },
    getters: {
        getPromoTypes: state => state.promoTypes,

        getLabelPromoTypes: state => state.typesPromoLabel,

        getPromoTypesForFilters: state => allowedPromoTypes => {
            let types = state.promoTypes

            if (allowedPromoTypes) {
                // Limit the results only to those provided in the argument
                types = types.filter(({ type }) => allowedPromoTypes.includes(type))
            }

            return types.map(({ type, name }) => ({ value: type, label: name }))
        },

        getPromoTypeByValue: state => value => {
            return (state.promoTypes || []).find(item => item.type === value)
                ? state.promoTypes.find(item => item.type === value).name
                : jsonPromoTypes[value]
                    ? jsonPromoTypes[value]
                    : value
        },

        getBondedTypes: state => state.typesBonded,

        isBonded: state => value => state.typesBonded.includes(value),

        isMix: state => value => state.typesMix.includes(value),

        isWeight: state => value => state.typesWeight.includes(value),

        isMarginType: state => value => state.typesMargin.includes(value),

        isLabelType: state => value => state.typesPromoLabel.includes(value),

        hasProductSets: state => value => state.typesSet.includes(value),

        isNoItemsPromo: state => type => state.typesNoItems.includes(type),

        isNoNetReturnPromo: state => type => state.typesNoNetReturn.includes(type),

        isEditablePromo: state => value => state.typesPromoEdit.includes(value),

        getEnableTypesPromoByLabelFormat: state => type => state.enableTypesPromoByLabelFormat[type]
    }
}
